import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import _cloneDeep from 'lodash-es/cloneDeep'

import * as state from '../../../../../../../../state'
import * as common from '../../../../common'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.illustration.emptyState.Component,
    common.glFilter.Component,
  ],
  selector: 'atn-rate-gl-filter-slideout',
  standalone: true,
  styleUrls: ['./filter-slideout.component.scss'],
  templateUrl: './filter-slideout.component.html',
})
export class AtnFilterSlideoutComponent {
  public readonly glRecordEc = ngCore.inject(state.rate.gl.records.Collection)

  public readonly ruleEc = ngCore.inject(state.rate.gl.rules.Collection)

  // TODO: Probably rework this when filter is reworked to be a signal and work
  // with the ngrx. It will probably check the state to see if filter slideout
  // should be open.
  // NOTE: Emiting cancel click to general-ledger.component.ts
  // to modify the flag indicating whether to display the slideout in that
  // component.
  public closeClick = ngCore.output()

  // NOTE: Dispatching to set the filter params and emiting closeClick action to close the slideout
  public saveBtnClickHandler = () => {
    this.glRecordEc.plugins.currentListPlugin.feature.actions.applyParams
      .from('FilterSlideout.Footer.Buttons.Update.Clicked')
      .dispatch()
    this.closeClick.emit()
  }

  /**
   * Creates a new {@link ents.extra.rate.gl.Rule} with prefilled conditions
   * from {@link CurrentListPlugin.appliedParams}
   */
  public createRuleHandler(): void {
    const filter =
      this.glRecordEc.plugins.currentListPlugin.appliedParams.selectors.filters.asSignal()

    this.ruleEc.plugins.editingPlugin.feature.actions.edit
      .from('GlFiltersSlide-out.Header.Buttons.CreateRule.Clicked')
      .dispatch({
        edit: {
          input: {
            filter,
          },
        },
      })
  }
}
